import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import Roboto from "../../../fonts/Roboto-Medium.ttf";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

Font.register({
  family: "Roboto",
  src: Roboto,
});
// 1. Create styles for PDF
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 8,
  },
  table: {
    display: "table",
    width: "auto",
    // borderStyle: "solid",
    // borderWidth: 1,
    // borderColor: "#bfbfbf",
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: "row",
    padding: 5,
    borderRadius: 4,
    color: "#333",
  },
  evenRow: {
    backgroundColor: "#fff", // light gray
  },
  oddRow: {
    backgroundColor: "#efd3d2ee", // white
  },
  tableCol: {
    fontFamily: "Roboto",
    fontWeight: "normal",
  },
  tableHeader: {
    backgroundColor: "#dd716d",
    color: "white",
    fontWeight: "bold",
    borderRadius: 4,
    fontSize: 10,
  },
});

// 2. PDF Document Component
const PDFDocument = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={{ marginBottom: 10, fontSize: 10 }}>Students</Text>

      <View style={styles.table}>
        {/* Header */}
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.tableCol, { width: 30 }]}>S/N</Text>
          <Text style={[styles.tableCol, { width: 140, fontWeight: "bold" }]}>
            Student Name
          </Text>
          <Text style={[styles.tableCol, { width: 100 }]}>Admission No.</Text>
          <Text style={[styles.tableCol, { width: 60 }]}>Gender</Text>
          <Text style={[styles.tableCol, { width: 120 }]}>Department</Text>
          <Text style={[styles.tableCol, { width: 100 }]}>Phone Number</Text>
          <Text style={[styles.tableCol, { width: 100 }]}>Origin</Text>
          <Text style={[styles.tableCol, { width: 80 }]}>Action</Text>
        </View>

        {/* Rows */}
        {data?.map((student, index) => (
          <View
            style={[
              styles.tableRow,
              index % 2 === 0 ? styles.evenRow : styles.oddRow,
            ]}
            key={index}
          >
            <Text style={[styles.tableCol, { width: 30, textAlign: "center" }]}>
              {index + 1}
            </Text>
            <Text style={[styles.tableCol, { width: 140, fontWeight: "bold" }]}>
              {student.personalInfo?.first_Name +
                " " +
                student.personalInfo?.sur_Name +
                " " +
                student.personalInfo?.other_Name}
            </Text>
            <Text style={[styles.tableCol, { width: 100 }]}>
              {student.academicInfo?.admission_number}
            </Text>
            <Text style={[styles.tableCol, { width: 60 }]}>
              {student.personalInfo?.gender}
            </Text>
            <Text style={[styles.tableCol, { width: 120 }]}>
              {student.academicInfo?.department}
            </Text>
            <Text style={[styles.tableCol, { width: 100 }]}>
              +234{student.contactInfo?.phone}
            </Text>
            <Text style={[styles.tableCol, { width: 100 }]}>
              {student.personalInfo?.permanent_home_address?.State_of_origin ||
                "-"}
            </Text>
            <Text style={[styles.tableCol, { width: 80, textAlign: "center" }]}>
              {student.academicInfo?.course_of_study || "-"}
            </Text>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

// 3. Button Component
const ExportPDFButton = ({ currentRows, dataFetch }) => (
  <PDFDownloadLink
    document={<PDFDocument data={currentRows} />}
    fileName="Manga Collge of Nursing Sciences Zuru.pdf"
  >
    {({ loading }) =>
      loading ? (
        <span style={{ fontSize: "1rem" }}> Preparing PDF...</span>
      ) : (
        <button className="btnExport">
          <PictureAsPdfIcon fontSize="large" />
        </button>
      )
    }
  </PDFDownloadLink>
);

export default ExportPDFButton;

// Ceviche One, Humanst521 BT
